export interface ILinkModel {
    appId?: string,
    name: string,
    description: string,
    url: string,
    startDate: any,
    endDate: any,
    iconText?: string,
    departmentOptions: any[],
    enterpriseId? :string,
    loginId?: string,
    createdOn?: string,
    createdBy?: string,
    lastUpdatedBy?: string,
    lastUpdatedOn?: string
}

export const defaultLinkModel = {
    name: "",
    description: "",
    url: "",
    startDate: null,
    endDate: null,
    iconText: "",
    department: [],
    enterpriseId: "",
    loginId: ""
};